// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LoyaltySoftGatePopup-module-container-21sHI{display:flex;flex-direction:column;justify-content:center;align-items:center;padding:40px;gap:20px}.LoyaltySoftGatePopup-module-btns-0RDTD{display:flex;gap:20px;-webkit-padding-before:20px;padding-block-start:20px}.LoyaltySoftGatePopup-module-logoWrapper-zmxk5 img{width:100px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "LoyaltySoftGatePopup-module-container-21sHI",
	"btns": "LoyaltySoftGatePopup-module-btns-0RDTD",
	"logoWrapper": "LoyaltySoftGatePopup-module-logoWrapper-zmxk5"
};
export default ___CSS_LOADER_EXPORT___;
